import documentType from './document-type';
import favoritType from './favorit-type';
import commons from './common';
import reconciliation from './reconciliation';
import sliderconsts from './slider'

export default function constants(app) {
	favoritType(app);
	documentType(app);
	commons(app);
	reconciliation(app);
	sliderconsts(app);
}
